import { parseJSON } from 'date-fns';
import { PreferencesState } from '../state';
import {
  ConciliationsStateTimeLapse,
  ConciliationStatus,
  MasterData,
  ReprocessParameters,
} from '../types';

const USER_PREFERENCES_KEY = 'preferences';
const DASHBOARD_DATE_KEY = 'dashboard-date';
const MASTER_DATE_KEY = 'master-data';
const DASHBOARD_CONCILIATIONS_STATE_KEY = 'dashboard-conciliations-state';
const REPROCESS_PARAMETERS_KEY = 'reprocess-parameters';

class AppStorage {
  static setUserPreferences(preferences: PreferencesState) {
    localStorage.setItem(USER_PREFERENCES_KEY, JSON.stringify(preferences));
  }

  static getUserPreferences(): PreferencesState | null {
    return JSON.parse(localStorage.getItem(USER_PREFERENCES_KEY) || 'null');
  }

  static setMasterData(masterData: MasterData) {
    sessionStorage.setItem(MASTER_DATE_KEY, JSON.stringify(masterData));
  }

  static getMasterData() {
    return JSON.parse(sessionStorage.getItem(MASTER_DATE_KEY) || 'null');
  }

  static setDashboardConciliationsStateData(
    dashboard: 'multiCountry' | 'card',
    timeLapse: ConciliationsStateTimeLapse,
    data: ConciliationStatus[],
    expiredDate: Date,
    country?: string
  ) {
    const modifierByCountryKey = country ? `${country}-` : '';
    const key = `${DASHBOARD_CONCILIATIONS_STATE_KEY}-${modifierByCountryKey}${dashboard}-${timeLapse}`;
    sessionStorage.setItem(key, JSON.stringify(data));
    sessionStorage.setItem(DASHBOARD_DATE_KEY, JSON.stringify(expiredDate));
  }

  static getDashboardConciliationsStateData(
    dashboard: 'multiCountry' | 'card',
    timeLapse: ConciliationsStateTimeLapse,
    country?: string
  ): ConciliationStatus[] | null {
    const modifierByCountryKey = country ? `${country}-` : '';
    const key = `${DASHBOARD_CONCILIATIONS_STATE_KEY}-${modifierByCountryKey}${dashboard}-${timeLapse}`;
    const expiredDate = JSON.parse(sessionStorage.getItem(DASHBOARD_DATE_KEY) || 'null');
    if (expiredDate && parseJSON(expiredDate) > new Date()) {
      const data = JSON.parse(sessionStorage.getItem(key) || 'null') as ConciliationStatus[];
      return data
        ? data.map(i => ({
            ...i,
            startDate: parseJSON(i.startDate),
            endDate: parseJSON(i.endDate),
          }))
        : null;
    }
    return null;
  }

  static removeDashboardData() {
    Object.keys(sessionStorage).forEach(key => {
      if (key.includes(DASHBOARD_CONCILIATIONS_STATE_KEY)) sessionStorage.removeItem(key);
    });
  }

  static setReprocessParameters(reprocessParameters: ReprocessParameters) {
    sessionStorage.setItem(REPROCESS_PARAMETERS_KEY, JSON.stringify(reprocessParameters));
  }

  static getReprocessParameters() {
    return JSON.parse(sessionStorage.getItem(REPROCESS_PARAMETERS_KEY) || 'null');
  }
}

export default AppStorage;
